

import { CheckCircle, Mail, XCircle } from "lucide-react";
import { Link } from "react-router";
import { Button } from "@sunfish/ui";
import { Card, CardContent } from "@sunfish/ui";

type MessageType = "success" | "error" | "email";

interface AuthMessageCardProps {
  type: MessageType;
  title: string;
  message: string;
  linkText?: string;
  linkHref?: string;
  buttonText?: string;
  buttonHref?: string;
}

const iconMap = {
  success: CheckCircle,
  error: XCircle,
  email: Mail,
};

const iconColorMap = {
  success: "text-green-500 bg-green-500/20",
  error: "text-red-500 bg-red-500/20",
  email: "text-brand bg-brand/20",
};

export function AuthMessageCard({
  type,
  title,
  message,
  linkText,
  linkHref,
  buttonText,
  buttonHref,
}: AuthMessageCardProps) {
  const Icon = iconMap[type];

  return (
    <Card className={"min-w-[500px] max-w-[500px]"}>
      <CardContent className="py-12 text-center">
        <div className="mb-6 flex justify-center">
          <div className={`rounded-full p-4 ${iconColorMap[type]}`}>
            <Icon className="h-8 w-8" />
          </div>
        </div>
        <h2 className="mb-3 text-2xl font-bold dark:text-white text-slate-700">
          {title}
        </h2>
        <p className="mb-6 dark:text-slate-400 text-gray-400">{message}</p>
        {buttonText && buttonHref && (
          <Button
            variant="brand"
            size="lg"
            className="w-full rounded-xl"
            asChild
          >
            <Link className={"text-center w-full"} to={buttonHref}>
              {buttonText}
            </Link>
          </Button>
        )}
        {linkText && linkHref && (
          <Link
            to={linkHref}
            className="text-sm font-medium text-muted-foreground hover:underline"
          >
            {linkText}
          </Link>
        )}
      </CardContent>
    </Card>
  );
}
